import eyeLogo from '../images/eye-logo.png'
import smartEyeFooter from '../images/smart-eye-footer.png'
import insta from '../images/insta.png'
import fb from '../images/fb.png'
import linkedin from '../images/linkedin.png'
import youtube from '../images/youtube.png'

const Footer = () => {

    return (
        <footer className="flex bg-[#1D58E2] w-full h-28 relative px-8">
            <img src={eyeLogo} alt="eye" className='absolute right-10 h-28 ' />
            <div className='flex flex-col gap-2 py-5'>
                <img src={smartEyeFooter} alt="footerImg" className='h-6' />
                <div className='flex gap-3'>
                    <img src={insta} alt="insta" className='h-4 w-4 cursor-pointer' />
                    <img src={fb} alt="fb" className='h-4 w-4 cursor-pointer'/>
                    <img src={linkedin} alt="linkedin" className='h-4 w-4 cursor-pointer'/>
                    <img src={youtube} alt="youtube" className='h-4 w-4 cursor-pointer'/>
                </div>
                <div className='flex'>
                    <p className='text-sm text-white pr-5 border-r border-white'>Privacy Policy</p>
                    <p className='text-sm text-white px-5 border-r border-white'>Terms of Use</p>
                    <p className='text-sm text-white px-5 border-r border-white'>CCPA Opt Out</p>
                    <p className='text-sm text-white px-5'>Cookie Policy</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer